export function extractPdfUrl(data) {
  return (
    data?.pdf_url ||
    data?.url_link ||
    data?.pdf ||
    data?.report_url ||
    data?.report ||
    null
  );
}

export function extractCustomerImage(data) {
  return (
    data?.customer_image_base_64 ||
    data?.customer_image ||
    data?.selfie_base64 ||
    data?.selfie ||
    null
  );
}

export function sliceServiceResponse(data, serviceId, serviceNameLower) {
  if (Array.isArray(data?.credit_bureau)) {
    const item = data.credit_bureau.find(
      (it) =>
        it.service_id === serviceId ||
        it.id === serviceId ||
        (it.service_name || "").toLowerCase() === serviceNameLower,
    );
    if (item) return item.response !== undefined ? item.response : item;
  }
  if (data?.system_generated && Array.isArray(data.system_generated.services)) {
    const item = data.system_generated.services.find(
      (it) =>
        it.service_id === serviceId ||
        it.id === serviceId ||
        (it.service_name || "").toLowerCase() === serviceNameLower,
    );
    if (item) return { questions: item.questions || [] };
  }
  if (
    data?.financial_services &&
    Array.isArray(data.financial_services.services)
  ) {
    const item = data.financial_services.services.find(
      (it) =>
        it.service_id === serviceId ||
        it.id === serviceId ||
        (it.service_name || "").toLowerCase() === serviceNameLower,
    );
    if (item) return { questions: item.questions || [] };
  }
  return data?.response || data?.result || data?.data || data || null;
}

export function sliceServiceResponseDoc(data, serviceId, serviceNameLower) {
  if (Array.isArray(data?.credit_bureau)) {
    const item = data.credit_bureau.find(
      (it) =>
        it.service_id === serviceId ||
        it.id === serviceId ||
        (it.service_name || "").toLowerCase() === serviceNameLower,
    );
    if (item) return item.response_doc !== undefined ? item.response_doc : null;
  }
  return data?.response_doc || null;
}

export function parseServiceFetchPayload(data, serviceId, serviceNameLower) {
  const pdf_url = extractPdfUrl(data);
  const customer_image = extractCustomerImage(data);
  const response = sliceServiceResponse(data, serviceId, serviceNameLower);
  const response_doc = sliceServiceResponseDoc(
    data,
    serviceId,
    serviceNameLower,
  );
  const documents = data?.documents || [];
  return { pdf_url, customer_image, response, response_doc, documents };
}